import React, {  Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import AddShippingAddressOverlayDialogVerify from './addShippingAddressOverlayDialogVerify';
import {
	showAddressVerificationDialog,
	getAddressVerificationData,
	generateNewAddress,
	personShipTo,
	addressExceptionDispatch
} from '../../redux/actions';

class AddShippingAddressOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: true,
			showOtherFields: false,
			disableJobSiteAddress: false,
			errorMessage: '',
			selectedUS :true,
			enableCanadianAddress: false,
			params: {
				firstName: '',
				lastName: '',
				address1: '',
				address2: '',
				address3: '',
				address4: '',
				city: '',
				state: '',
				zip: '',
				country:'',
				county:'',
				province:'',
				postalCode:''
			},
			error: {
				firstNameError: '',
				lastNameError: '',
				address1Error: '',
				cityError: '',
				stateError: '',
				zipError: '',
				countryError: '',
				provinceError:'',
				postalCodeError:''
			}
        }
		this.handleEditAddress = this.handleEditAddress.bind(this);
		this.updateAddressFieldsFromSuggestedAddress = this.updateAddressFieldsFromSuggestedAddress.bind(this);
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('AddShippingAddressOverlayDialog');
    }
	onChangeUpdateParam(event) {
        const self = this;
		let { name, value, type, checked } = event.target;
		if (type === 'checkbox') {
			value = checked ? event.target.value : '';
		}
		if(value === 'CA' && name == 'country') {
			self.setState({
		 		selectedUS: false
			});
		} else if(value === 'US' && name == 'country') {
			self.setState({
			  	selectedUS: true
			})
		 }
        self.setState({
			params: {
				...self.state.params,
				[name]: value
			}
        });
		if(self.state.error[name+"Error"]) {
			self.setState({
				error: {
					...self.state.error,
					[name+"Error"]: ""
				}
	        });
		}
    }
	handleContinue(event) {
		event.preventDefault();
		var self = this,
            params = self.state.params,
			error = self.state.error,
            formError = false;

		self.setState({
			errorMessage: ''
		})

        for(var key in error) {
            if(params[key.replace("Error","")] === "") {
				if(!self.state.enableCanadianAddress && (key == "countryError" || key== "postalCodeError" || key == "provinceError" )){
					error[key] = '';
				}else{
					error[key] = 'error';
					formError = true;
				}  
            } else {
				error[key] = '';
			}
        }
		//Check length for zipcode
		if(self.state.selectedUS && !/\d{5}(-?\d{4})?$/.test(params.zip)) {
				formError = true;
				error.zipError = "error";
		}else{
			// if(!/\d{5}(-?\d{4})?$/.test(params.postalCode)) {
			// 	formError = true;
			// 	error.postalCodeError = "error";
			// }
			params.postalCode = params && params.postalCode;
		}

		self.setState({
			params: params,
			error: error
		});
		if(!formError) {
			params.zipCode = params.zip;
			self.props.showAddressVerificationDialog(false);
			params.country = self.state.selectedUS ? "US" : "CA";
			params.state = self.state.selectedUS ? params.state : params.province;
			params.zipCode = self.state.selectedUS ? params.zipCode : params.postalCode;
			localStorage.setItem("address3Continue", params.address3);
			const queryString = "address1="+encodeURIComponent(params.address1)+"&address2="+encodeURIComponent(params.address2)+"&address3="+encodeURIComponent(params.address3)+"&city="+params.city+"&state="+params.state+"&zip="+params.zipCode+"&country="+params.country+"&requestType=validateAddress";
			self.props.getAddressVerificationData(queryString, response => {
				self.props.showAddressVerificationDialog(true);
			});
		}
	}
	handleEditAddress(whichAddress, event) {
		event.preventDefault();
		if(whichAddress === "asCorrected") {
			this.updateAddressFieldsFromSuggestedAddress();
		}
		//hide address selection dialog
		this.props.showAddressVerificationDialog(false);
	}
	handleUseSelectedAddress(enteredAddressIsCorrectOrNot, event) {
		event.preventDefault();
		//If entered address is selected
		const self = this;
		const { showOtherFields } = self.state;
		let body = self.state.params;
		if(!enteredAddressIsCorrectOrNot) {
			body = self.updateAddressFieldsFromSuggestedAddress();
		}
		self.props.addressExceptionDispatch(true);
		const { selectedAccount } = self.props.state.user;
		const payload = {
			firstName: self.state.params.firstName,
			lastName: self.state.params.lastName,
			accountId: selectedAccount.ACCOUNTID,
			orgName: selectedAccount.ORGANIZATIONNAME,
			accountPartyId: selectedAccount.PARTYID,
			customerClassification: selectedAccount.CUSTOMERCLASSCODE,
			address1: body.address1,
			address2: body.address2,
			address3: body.address3,
			address4: body.address4,
			city: body.city,
			state: body.state,
			zip: body.zip,
			postalCode: body.postalCode,
			country:body.country,
			county:body.county,
			province:body.province
		};
		// make new service call with first name and last name
		self.props.personShipTo(payload, (response) => {
			//hide address selection dialog
			self.props.showAddressVerificationDialog(false);
			if(response.status && response.responseObject && response.responseObject.siteUseId) {
				body = {
					...body,
					addressId: response.responseObject.siteUseId.toString(),
				}
				self.props.handleCallBackAfterAddedNewAddress(body, false);
			} else {
				if (showOtherFields) {
					self.setState({
						errorMessage: 'Error occured while creating consumer ship to.'
					});
				} else {
					self.props.handleCallBackAfterAddedNewAddress(body, false);
				}
			}
		});
	}
	componentDidMount() {
		// window.scrollTo(0, 0);
		const self = this,
			{ showOtherFieldsInAddShippingAddress } = self.props,
			{ selectedAccount, addressList } = self.props.state.user,
			customerClassCode = selectedAccount && selectedAccount.CUSTOMERCLASSCODE ? selectedAccount.CUSTOMERCLASSCODE.toLowerCase() : "",
			salesChannelCode = selectedAccount && (selectedAccount.SALESCHANNEL || selectedAccount.SALESCHANNELCODE);
			if (addressList.responseObject.find(itm => itm.PURPOSE === "SOLD_TO" && itm.COUNTRY === 'CA' && itm.STATUS === 'A') && salesChannelCode === 'PRO CHANNEL') {
				self.setState({
					enableCanadianAddress: true
				})
			}
		let showOtherFields = true;
		const { params, error } = self.state;
		let disableJobSiteAddress = false;
		if (!showOtherFieldsInAddShippingAddress) {
			showOtherFields = false;
			delete params.firstName;
			delete params.lastName;
			delete error.firstNameError;
			delete error.lastNameError;
			delete error.countryError;
			delete error.provinceError;
			delete error.postalCodeError;
			delete error.stateError;
			delete error.zipError;
			if (customerClassCode === 'single family' || customerClassCode === 'single family renovation') {
				disableJobSiteAddress = true;
				params.address4 = 'JOB SITE';
			}
		} else {
			delete params.address4;
		}
		self.setState({
			showOtherFields,
			params,
			error,
			disableJobSiteAddress,
            showDialog: self.props.showDialog
        });
	}
	updateAddressFieldsFromSuggestedAddress() {
		const self = this;
		let params = self.state.params;
		const data = this.props.state.registration && this.props.state.registration.addressVerificationData && this.props.state.registration.addressVerificationData.responseObject,
			address1 = data.addressline1 && data.addressline1.trim(),
			address2 = params.address2 && params.address2.trim(),
			address3 = params.address3 && params.address3.trim(),
			city = data.city && data.city.trim(),
			country = data.country && data.country.trim() != "United States of America"? "CA":"US",
			county = data.county && data.county.trim(),
			province = data.state && data.state.trim(),
			state =  data.state && data.state.trim(),
			zip = data.postalcode && data.postalcode.trim();
		params = {
			...params,
			address1,
			address2,
			address3,
			city,
			county,
			province,
			state,
			zip,
			zipCode: zip,
		};
		self.setState({
			params: params
		});
		return params;
	}
    render() {
		const { registration, user } = this.props.state;
		const { showOtherFields, disableJobSiteAddress } = this.state;
		const { selectedAccount } = user;
        return (
			<div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="addShippingAddressOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Add New Shipping Address</h2>
					<p className="red bold">{this.state.errorMessage}</p>
					<p className="required-disclaimer">* Indicates required information</p>
                    <form className="addNewShippingAddressForm" onSubmit={(e) => e.preventDefault()}>
                        <table width="100%" className="formTableTypeA width35Col1 addNewShippingAddressTable full-width-fields">
                            <tbody>
								{showOtherFields && <tr>
									<td><span className="required">*</span>First Name</td>
									<td>
										<input type="text" placeholder="First Name" className={this.state.error.firstNameError} onChange={this.onChangeUpdateParam.bind(this)} name="firstName" value={this.state.params.firstName} />
									</td>
								</tr>}
								{showOtherFields && <tr>
									<td><span className="required">*</span>Last Name</td>
									<td>
										<input type="text" placeholder="Last Name" className={this.state.error.lastNameError} onChange={this.onChangeUpdateParam.bind(this)} name="lastName" value={this.state.params.lastName} />
									</td>
								</tr>}
								{this.state.enableCanadianAddress ?<tr>
                                    <td><span className="required">*</span>Country</td>
									<td>
                                        <select name="country" className={this.state.error.countryError} onChange={this.onChangeUpdateParam.bind(this)} value={this.state.params.country}>
										<option value="">Select…</option>
											<option value="US">United States</option>
											<option value="CA">Canada</option>
										</select>
									</td>
								</tr>:""}
								{!showOtherFields && <tr>
									<td></td>
									<td>
										{selectedAccount ? selectedAccount.ORGANIZATIONNAME : ''}
									</td>
								</tr>}
                                <tr>
                                    <td><span className="required">*</span>Address 1</td>
                                    <td>
                                        <input type="text" placeholder="street address" className={this.state.error.address1Error} onChange={this.onChangeUpdateParam.bind(this)} name="address1" value={this.state.params.address1} />
                                    </td>
                                </tr>
								<tr>
                                    <td>Address 2</td>
                                    <td>
                                        <input type="text" placeholder="subdivision/project name" onChange={this.onChangeUpdateParam.bind(this)} name="address2" value={this.state.params.address2} />
                                    </td>
                                </tr>
								<tr>
                                    <td>Address 3</td>
                                    <td>
                                        <input maxLength={8} type="text" placeholder="Lot#" onChange={this.onChangeUpdateParam.bind(this)} name="address3" value={this.state.params.address3} />
                                    </td>
                                </tr>
                            	<tr>
                                    <td><span className="required">*</span>City</td>
                                    <td>
                                        <input type="text" className={this.state.error.cityError} onChange={this.onChangeUpdateParam.bind(this)} name="city" value={this.state.params.city} />
                                    </td>
                                </tr>
                                <tr>
								<td><span className="required">*</span>{this.state.selectedUS ? 'State' : 'Province/Territory'}</td>
                                    <td>
									{this.state.selectedUS ? <select name="state" className={this.state.error.stateError} onChange={this.onChangeUpdateParam.bind(this)} value={this.state.params.state}>
											<option value="">Select…</option>
											<option value="AL">Alabama</option>
											<option value="AK">Alaska</option>
											<option value="AZ">Arizona</option>
											<option value="AR">Arkansas</option>
											<option value="CA">California</option>
											<option value="CO">Colorado</option>
											<option value="CT">Connecticut</option>
											<option value="DE">Delaware</option>
											<option value="FL">Florida</option>
											<option value="GA">Georgia</option>
											<option value="HI">Hawaii</option>
											<option value="ID">Idaho</option>
											<option value="IL">Illinois</option>
											<option value="IN">Indiana</option>
											<option value="IA">Iowa</option>
											<option value="KS">Kansas</option>
											<option value="KY">Kentucky</option>
											<option value="LA">Louisiana</option>
											<option value="ME">Maine</option>
											<option value="MD">Maryland</option>
											<option value="MA">Massachusetts</option>
											<option value="MI">Michigan</option>
											<option value="MN">Minnesota</option>
											<option value="MS">Mississippi</option>
											<option value="MO">Missouri</option>
											<option value="MT">Montana</option>
											<option value="NE">Nebraska</option>
											<option value="NV">Nevada</option>
											<option value="NH">New Hampshire</option>
											<option value="NJ">New Jersey</option>
											<option value="NM">New Mexico</option>
											<option value="NY">New York</option>
											<option value="NC">North Carolina</option>
											<option value="ND">North Dakota</option>
											<option value="OH">Ohio</option>
											<option value="OK">Oklahoma</option>
											<option value="OR">Oregon</option>
											<option value="PA">Pennsylvania</option>
											<option value="RI">Rhode Island</option>
											<option value="SC">South Carolina</option>
											<option value="SD">South Dakota</option>
											<option value="TN">Tennessee</option>
											<option value="TX">Texas</option>
											<option value="UT">Utah</option>
											<option value="VT">Vermont</option>
											<option value="VA">Virginia</option>
											<option value="WA">Washington</option>
											<option value="WV">West Virginia</option>
											<option value="WI">Wisconsin</option>
											<option value="WY">Wyoming</option>
											<option value="DC">District of Columbia</option>
											</select>:<select id="province" name="province" className={this.state.error.provinceError} onChange={this.onChangeUpdateParam.bind(this)} value={this.state.params.province}>
											   <option value="">Select…</option>
											   <option value="AB">Alberta</option>
											   <option value="BC">British Columbia</option>
											   <option value="MB">Manitoba</option>
											   <option value="NB">New Brunswick</option>
											   <option value="NL">Newfoundland and Labrador</option>
											   <option value="NT">Northwest Territories</option>
											   <option value="NS">Nova Scotia</option>
											   <option value="NU">Nunavut</option>
											   <option value="ON">Ontario</option>
											   <option value="PE">Prince Edward Island</option>
											   <option value="QC">Quebec</option>
											   <option value="SK">Saskatchewan</option>
											   <option value="YT">Yukon</option>
											</select>}
                                    </td>
                                </tr>
                                <tr>
								<td><span className="required">*</span>{this.state.selectedUS ? 'Zip Code' : 'Postal Code'}</td>
                                    <td>
									{this.state.selectedUS ? <input type="text" className={this.state.error.zipError} onChange={this.onChangeUpdateParam.bind(this)} name="zip" size={10} maxLength={10} value={this.state.params.zip} />:
										<input type="text" className={this.state.error.postalCodeError} onChange={this.onChangeUpdateParam.bind(this)} name="postalCode" size={10} maxLength={10} value={this.state.params.postalCode} />}
                                    </td>
                                </tr>
								{!showOtherFields && <tr>
                                    <td>Job Site Address</td>
                                    <td>
                                        <input style={{width: 'auto'}} type="checkbox" onChange={this.onChangeUpdateParam.bind(this)} name="address4" value="JOB SITE" checked={this.state.params.address4} disabled={disableJobSiteAddress} />
                                    </td>
                                </tr>}
                            </tbody>
                        </table>
                        <div className="noButtonContainer">
                          	<a className="noButton blueButton" onClick={this.closeDialog.bind(this)}>Cancel</a>
                        </div>
                        <div className="yesButtonContainer">
                            <a className="yesButton blueButton" onClick={this.handleContinue.bind(this)}>Continue</a>
                        </div>
                    </form>
                </div>
				{registration.showAddressVerificationDialog?<AddShippingAddressOverlayDialogVerify handleEditAddress={this.handleEditAddress} suggestedAddress={registration.addressVerificationData} existingAddress={this.state.params} handleUseSelectedAddress={this.handleUseSelectedAddress.bind(this)} showDialog={true} />:null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	showAddressVerificationDialog: (flag) => dispatch(showAddressVerificationDialog(flag)),
	addressExceptionDispatch: (flag) => dispatch(addressExceptionDispatch(flag)),
	getAddressVerificationData: (payload, callback) => dispatch(getAddressVerificationData(payload, callback)),
	personShipTo: (payload, callback) => dispatch(personShipTo(payload, callback)),
	generateNewAddress: (payload, queryStringParams, callback) => dispatch(generateNewAddress(payload, queryStringParams, callback))
})

AddShippingAddressOverlayDialog = connect(mapStateToProps, mapDispatchToProps)(AddShippingAddressOverlayDialog);
export default AddShippingAddressOverlayDialog;


// WEBPACK FOOTER //
// ./src/App/components/dialogs/addShippingAddressOverlayDialog.js